import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ButtonModule } from '@components/button/button.module';
import { IconModule } from '@components/icon/icon.module';
import { NDT_SNACK_BAR_DEFAULT_OPTIONS } from '@components/snack-bar/snack-bar';
import { NdtSnackBarConfig } from '@components/snack-bar/snack-bar-config';
import { NdtSnackBarModule } from '@components/snack-bar/snack-bar.module';

import { NotificationComponent } from './notification.component';
import { NotificationData } from './notification.interface';

const components = [NotificationComponent];
const snackBarOptions: NdtSnackBarConfig<NotificationData> = {
  direction: 'ltr',
  duration: 4000,
  horizontalPosition: 'left',
  verticalPosition: 'bottom',
  politeness: 'polite',
};

@NgModule({
  declarations: components,
  exports: components,
  imports: [CommonModule, ButtonModule, IconModule, NdtSnackBarModule],
  providers: [
    {
      provide: NDT_SNACK_BAR_DEFAULT_OPTIONS,
      useValue: snackBarOptions,
    },
  ],
})
export class NotificationModule {}
